import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox, ListItemText, MenuItem, Select } from '@material-ui/core'

const ALL_LABEL = 'All competitions'

const namesOf = (competitions, ids) =>
  ids.map((id) => competitions.find((competition) => competition.id === id)?.name).filter(Boolean)

/**
 * Where a Manager works: the whole org (nothing picked) or only the competitions picked. Read-only
 * rows show the same as text.
 */
const CompetitionScopePicker = ({ competitions, selected, disabled, readOnly, label, onChange }) => {
  const summary = selected.length === 0 ? ALL_LABEL : namesOf(competitions, selected).join(', ')

  if (readOnly) {
    return <span style={{ fontSize: 13, color: '#6b6b6b' }}>{summary}</span>
  }

  return (
    <Select
      multiple
      displayEmpty
      value={selected}
      disabled={disabled}
      onChange={(event) => onChange(event.target.value)}
      renderValue={() => summary}
      inputProps={{ 'aria-label': label }}
      style={{ minWidth: 180, maxWidth: 320, height: 32, fontSize: 13 }}
    >
      {competitions.map((competition) => (
        <MenuItem key={competition.id} value={competition.id}>
          <Checkbox size='small' checked={selected.includes(competition.id)} />
          <ListItemText primary={competition.name} />
        </MenuItem>
      ))}
    </Select>
  )
}

CompetitionScopePicker.propTypes = {
  competitions: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string, name: PropTypes.string })).isRequired,
  selected: PropTypes.arrayOf(PropTypes.string).isRequired,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func,
}

CompetitionScopePicker.defaultProps = { disabled: false, readOnly: false, onChange: () => {} }

export default CompetitionScopePicker
